export default function formatPaycheckNumber(paycheckNumber: string | null, prefix = true) {
  if (
    paycheckNumber === undefined ||
    paycheckNumber === null ||
    paycheckNumber === ''
  ) return paycheckNumber;

  return prefix ? `L ${paycheckNumber}` : paycheckNumber;
}
